import React, { useState, useEffect, useRef } from 'react';
import Navbar from '../components/navbar';
import PopUpModal from '../components/popupmodal';
import Footer from '../components/footer';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

// Image Imports
import Africanimage from "../public//fressh-food.jpg";
import secondimage from "../public/2ndimage.jpeg";
import thirdimage from "../public/third-image.jpeg";
import deliveryguy from "../public/driver-shutterstock_1146895727-1.jpg";
import womancooking from "../public/beautiful-woman-preparing-romantic-dinner.jpg";
import subbox from "../public/africfresh-box.jpeg";

import ProductSection from '../components/productsection';
import { allProductsPromise } from '../components/allProducts';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { IoCloseOutline } from "react-icons/io5";

import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


// Banner Component with Enhanced Image Loading and Animations
const Banner = ({ 
  imageUrl, 
  description, 
  buttons, 
  onButtonClick,
  isActive 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [textVisible, setTextVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    
    img.onload = () => {
      setImageLoaded(true);
      if (imageRef.current) {
        imageRef.current.style.backgroundImage = `url(${imageUrl})`;
      }
    };

    img.onerror = () => {
      console.error('Failed to load image:', imageUrl);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  useEffect(() => {
    if (isActive && imageLoaded) {
      const timer = setTimeout(() => {
        setTextVisible(true);
      }, 300);
      return () => clearTimeout(timer);
    } else {
      setTextVisible(false);
    }
  }, [isActive, imageLoaded]);

  return (
    <div 
      ref={imageRef}
      className={`
        relative 
        w-full 
        h-screen 
        bg-cover 
        min-h-screen
        bg-center 
        flex 
        items-center 
        justify-center 
        transition-all 
        duration-1000 
        ${isActive ? 'scale-100' : 'scale-105'}
      `}
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        touchAction: 'pan-y',
        filter: isActive ? 'brightness(1)' : 'brightness(0.8)',
      }}
    >
      {/* Animated Overlay */}
      <div className={`
        absolute inset-0 bg-black transition-opacity duration-1000
        ${isActive ? 'opacity-40' : 'opacity-60'}
      `}></div>
      
      {/* Animated Floating Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`
              absolute w-2 h-2 bg-white/20 rounded-full
              animate-float-${i + 1}
            `}
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${3 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>
      
      {/* Content with Staggered Animations */}
      <div className="relative z-10 text-center text-white px-4">
        {description && (
          <h2 className={`
            text-4xl md:text-5xl mb-6 uppercase font-bold
            transform transition-all duration-1000 ease-out
            ${textVisible 
              ? 'translate-y-0 opacity-100 scale-100' 
              : 'translate-y-8 opacity-0 scale-95'
            }
          `}
          style={{
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            animationDelay: '0.2s'
          }}
          >
            {description.split(' ').map((word, index) => (
              <span
                key={index}
                className={`
                  inline-block mr-2
                  transform transition-all duration-700 ease-out
                  ${textVisible 
                    ? 'translate-y-0 opacity-100' 
                    : 'translate-y-12 opacity-0'
                  }
                `}
                style={{
                  animationDelay: `${0.3 + index * 0.1}s`
                }}
              >
                {word}
              </span>
            ))}
          </h2>
        )}
        
        {buttons && (
          <div className={`
            space-x-4 mt-32
            transform transition-all duration-1000 ease-out
            ${textVisible 
              ? 'translate-y-0 opacity-100 scale-100' 
              : 'translate-y-12 opacity-0 scale-95'
            }
          `}
          style={{ animationDelay: '0.8s' }}
          >
            {buttons.map((buttonText, index) => (
              <button
                key={index}
                onClick={() => onButtonClick(buttonText)}
                className={`
                  px-6 py-3 
                  bg-[#007D44] 
                  text-white 
                  rounded-md 
                  hover:bg-[#F0B241] 
                  transition-all 
                  duration-300 
                  active:scale-95
                  hover:scale-105
                  hover:shadow-lg
                  transform
                  ${textVisible ? 'animate-bounce-gentle' : ''}
                `}
                style={{
                  animationDelay: `${1 + index * 0.2}s`,
                  boxShadow: '0 4px 15px rgba(0, 125, 68, 0.3)'
                }}
              >
                {buttonText}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Add custom CSS animations */}
      <style jsx>{`
        @keyframes float-1 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-20px); } }
        @keyframes float-2 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-15px); } }
        @keyframes float-3 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-25px); } }
        @keyframes float-4 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-18px); } }
        @keyframes float-5 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-22px); } }
        @keyframes float-6 { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-16px); } }
        
        @keyframes bounce-gentle {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-5px); }
          60% { transform: translateY(-3px); }
        }
        
        .animate-float-1 { animation: float-1 3s ease-in-out infinite; }
        .animate-float-2 { animation: float-2 3.5s ease-in-out infinite; }
        .animate-float-3 { animation: float-3 4s ease-in-out infinite; }
        .animate-float-4 { animation: float-4 3.2s ease-in-out infinite; }
        .animate-float-5 { animation: float-5 3.8s ease-in-out infinite; }
        .animate-float-6 { animation: float-6 3.3s ease-in-out infinite; }
        
        .animate-bounce-gentle { animation: bounce-gentle 2s ease-in-out; }
      `}</style>
    </div>
  );
};

// Shuffle Array Utility
const shuffleArray = (array) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

// Main App Component
function App() {
  const [showModal, setShowModal] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const [allProducts, setAllProducts] = useState([]);
  const [hotProducts, setHotProducts] = useState([]);
  const [freshVeggies, setFreshVeggies] = useState([]);
  const [beverages, setBeverages] = useState([]);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [subscriptionVisible, setSubscriptionVisible] = useState(false);

  const hotProductsRef = useRef(null);
  const subscriptionRef = useRef(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();

  // Intersection Observer for subscription section
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSubscriptionVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (subscriptionRef.current) {
      observer.observe(subscriptionRef.current);
    }

    return () => {
      if (subscriptionRef.current) {
        observer.unobserve(subscriptionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      // 1. Get user details and token separately
      const userDetails = JSON.parse(localStorage.getItem('AficFreshuserDetails'));
      const token = localStorage.getItem('AficFreshtoken'); // Typically stored separately
      
      const userEmail = userDetails?.email;
  
      console.log('User Email:', userEmail);
      console.log('Token exists:', !!token);
  
      if (!userEmail || !token) {
        console.log('Missing user email or token');
        return;
      }
  
      try {
        const response = await axios.get(
          `https://afric-fresh-backend.onrender.com/user/subscription-details?email=${userEmail}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        
        const subscription = response.data.subscription;
        console.log("Full subscription data:", subscription);
  
        const now = new Date();
        const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        console.log("Current month:", currentYearMonth);
  
        const hasOrderForCurrentMonth = subscription.some(sub =>
          sub.orders.some(order => order.orderMonth === currentYearMonth)
        );
  
        console.log("Has order for current month:", hasOrderForCurrentMonth);
  
        if (hasOrderForCurrentMonth) {
          setIsButtonDisabled(true);
          startCountdown();
        } else {
          setIsButtonDisabled(false);
        }
  
        const activeSubscription = subscription.find(sub => sub.status === 'active');
        if (activeSubscription) {
          setSubscriptionStatus(activeSubscription.type);
        }
      } catch (error) {
        console.error('Error fetching subscription details:', error);
        
        if (error.response) {
          // The request was made and the server responded with a status code
          console.error('Response data:', error.response.data);
          console.error('Response status:', error.response.status);
          console.error('Response headers:', error.response.headers);
          
          if (error.response.status === 401) {
            // Token is invalid or expired
            console.log('Token is invalid or expired');
            // You might want to redirect to login here
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error('No response received:', error.request);
        } else {
          // Something happened in setting up the request
          console.error('Request setup error:', error.message);
        }
      }
    };
  
    fetchSubscriptionDetails();
  }, []);

  const startCountdown = () => {
    const now = new Date();
    const houstonTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Chicago" }));
    const nextMonth = new Date(houstonTime.getFullYear(), houstonTime.getMonth() + 1, 1);
    const timeRemaining = nextMonth - houstonTime;
  
    const interval = setInterval(() => {
      const now = new Date();
      const houstonTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Chicago" }));
      const timeRemaining = nextMonth - houstonTime;
  
      if (timeRemaining <= 0) {
        clearInterval(interval);
        setIsButtonDisabled(false);
        setCountdown(null);
      } else {
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  
        setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s`);
      }
    }, 1000);
  };

  const [isProductsLoading, setIsProductsLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsProductsLoading(true);
        const products = await allProductsPromise;
        setAllProducts(products);
  
        const hot = shuffleArray(products).slice(0, 10);
        const veggies = products.filter((p) => p.category === "vegetableproducts");
        const beverageProducts = products.filter((p) => p.category === "beveragesproducts");
  
        setHotProducts(hot);
        setFreshVeggies(veggies);
        setBeverages(beverageProducts);
        setIsProductsLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setIsProductsLoading(false);
      }
    };
  
    fetchProducts();
  }, []);

  // Banner Configuration
  const banners = [
    {
      id: 1,
      imageUrl: secondimage,
      description: 'Rediscover African cooking with fresh flavours.',
      buttons: null
    },
    {
      id: 2,
      imageUrl: Africanimage,
      description: 'Always fresh African groceries.',
      buttons: null
    },
    
    {
      id: 3,
      imageUrl: deliveryguy,
      description: 'AfricFresh! Delivered fresh from start to finish.',
      buttons: null
    },
    {
      id: 4,
      imageUrl: womancooking,
      description: "Discover new recipes.",
      buttons: ['Visit Blog']
    },
    {
      id: 5,
      imageUrl: thirdimage,
      description: "",
      buttons: ['Shop Now', 'Contact Us']
    }
  ];

  // Banner Button Click Handler
const handleBannerButtonClick = (buttonText) => {
  switch(buttonText) {
    case "Shop Now":
      const hotProductsElement = document.getElementById('hot-products');
      if (hotProductsElement) {
        hotProductsElement.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });

        window.scrollTo({
          top: hotProductsElement.offsetTop - 100,
          behavior: 'smooth'
        });
      } else {
        console.warn('Hot products section not found');
      }
      break;
    
    case "Contact Us":
      navigate('/contactform');
      break;
    
    case "Visit Blog":
      navigate('/blog');
      break;
  }
};

useEffect(() => {
  const checkHotProductsPosition = () => {
    const hotProductsElement = document.getElementById('hot-products');
    if (hotProductsElement) {
      console.group('Hot Products Section Details');
      console.log('Offset Top:', hotProductsElement.offsetTop);
      console.log('Client Height:', hotProductsElement.clientHeight);
      console.log('Scroll Position:', window.scrollY);
      console.log('Window Inner Height:', window.innerHeight);
      console.groupEnd();
    } else {
      console.warn('Hot products section not found in the DOM');
    }
  };

  checkHotProductsPosition();
  window.addEventListener('scroll', checkHotProductsPosition);
  window.addEventListener('resize', checkHotProductsPosition);

  return () => {
    window.removeEventListener('scroll', checkHotProductsPosition);
    window.removeEventListener('resize', checkHotProductsPosition);
  };
}, []);

  // Auto Banner Advance
  useEffect(() => {
    const bannerInterval = setInterval(() => {
      setCurrentBannerIndex((prev) => 
        (prev + 1) % banners.length
      );
    }, 5000);

    return () => clearInterval(bannerInterval);
  }, []);

  // Manual Banner Navigation
  const nextBanner = () => {
    setCurrentBannerIndex((prev) => 
      (prev + 1) % banners.length
    );
  };

  const prevBanner = () => {
    setCurrentBannerIndex((prev) => 
      (prev - 1 + banners.length) % banners.length
    );
  };

  // Modal and Cart Logic
  const openModal = () => setIsModalOpen(true);
  const [loading, setLoading] = useState(false);

  const cancelModal = () => setIsModalOpen(false);

  const closeModal = async () => {
    const userDetails = JSON.parse(localStorage.getItem('AficFreshuserDetails'));
    const userEmail = userDetails?.email;
  
    if (!userEmail) {
      Swal.fire({
        title: 'Oops!',
        html: `
          <div class="text-center">
            <p class="text-lg">You are not logged in. Please log in to proceed with the subscription plan.</p>
          </div>
        `,
        icon: 'warning',
        showCloseButton: true,
        closeButtonHtml: '✖',
        showConfirmButton: true,
        confirmButtonText: 'Go to Login',
        confirmButtonColor: '#007D44',
        showCancelButton: true,
        cancelButtonText: 'Close',
        cancelButtonColor: '#d33',
        timer: 40000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.getPopup().style.transform = 'scale(0.8)';
          Swal.getPopup().style.transition = 'transform 0.3s ease';
          setTimeout(() => {
            Swal.getPopup().style.transform = 'scale(1)';
          }, 10);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/auth/login');
        }
      });
      return;
    }
  
    try {
      setLoading(true);
  
      const response = await axios.post(
        `https://afric-fresh-backend.onrender.com/user/send-subscription-email`, {
        email: userEmail,
        plan: selectedPlan
      });
  
      const updatedUser = response.data.user;
      localStorage.setItem('AficFreshuserDetails', JSON.stringify(updatedUser));
  
      if (selectedPlan === 'large') {
        navigate('/largebox');
      } else if (selectedPlan === 'small') {
        navigate('/smallbox');
      }
  
      setIsModalOpen(false);
      setIsAccepted(false);
      setSelectedPlan(null);
    } catch (error) {
      console.log('Error sending subscription email:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to send subscription confirmation email. Please try again.',
        icon: 'error',
        confirmButtonColor: '#007D44',
      });
    }
  };

  // Cart and Local Storage Effects
  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
  };

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      nextBanner();
    }

    if (touchStart - touchEnd < -75) {
      prevBanner();
    }
  };

  return (
    <div className="App">
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} />
      <PopUpModal showModal={showModal} setShowModal={setShowModal} />
  
      {/* Enhanced Banner Section */}
      <div className="relative w-full h-screen overflow-hidden mt-20 max-sm:mt-32"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {banners.map((banner, index) => (
          <div 
            key={banner.id}
            className={`
              absolute 
              top-0 
              left-0 
              w-full 
              h-full 
              transition-all 
              duration-1000 
              ease-in-out
              ${index === currentBannerIndex 
                ? 'opacity-100 z-20 scale-100' 
                : 'opacity-0 z-10 scale-105'
              }
            `}
          >
            <Banner 
              imageUrl={banner.imageUrl}
              description={banner.description}
              buttons={banner.buttons}
              onButtonClick={handleBannerButtonClick}
              isActive={index === currentBannerIndex}
            />
          </div>
        ))}

        {/* Enhanced Navigation Arrows */}
        <div className="
          absolute 
          top-1/2 
          transform 
          -translate-y-1/2 
          w-full  
          justify-between 
          px-4 
          z-30
          hidden
          md:flex
        ">
          <button 
            onClick={prevBanner}
            className="
              bg-white/70 
              backdrop-blur-sm
              rounded-full 
              p-3 
              hover:bg-white/90 
              hover:scale-110
              transition-all
              duration-300
              shadow-lg
              group
            "
          >
            <FaChevronLeft size={24} color="#007D44" className="group-hover:scale-110 transition-transform duration-200" />
          </button>
          <button 
            onClick={nextBanner}
            className="
              bg-white/70 
              backdrop-blur-sm
              rounded-full 
              p-3 
              hover:bg-white/90 
              hover:scale-110
              transition-all
              duration-300
              shadow-lg
              group
            "
          >
            <FaChevronRight size={24} color="#007D44" className="group-hover:scale-110 transition-transform duration-200" />
          </button>
        </div>

        {/* Animated Banner Indicators */}
        <div className="
          absolute 
          bottom-8 
          left-1/2 
          transform 
          -translate-x-1/2 
          flex 
          space-x-3 
          z-30
        ">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentBannerIndex(index)}
              className={`
                w-3 h-3 rounded-full transition-all duration-500 ease-out
                ${index === currentBannerIndex 
                  ? 'bg-white scale-125 shadow-lg' 
                  : 'bg-white/50 hover:bg-white/75 hover:scale-110'
                }
              `}
            />
          ))}
        </div>
      </div>

    {/* Enhanced Subscription Plan Banner */}
    <div 
      ref={subscriptionRef}
      className={`
        flex flex-col md:flex-row items-center justify-between 
        bg-gradient-to-r from-white via-green-50 to-white
        p-6 md:p-8 rounded-xl shadow-xl my-10 mx-auto max-w-screen-lg 
        space-y-6 md:space-y-0 relative overflow-hidden
        transform transition-all duration-1000 ease-out
        ${subscriptionVisible 
          ? 'translate-y-0 opacity-100 scale-100' 
          : 'translate-y-12 opacity-0 scale-95'
        }
      `}
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-green-200/30 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      {subscriptionStatus ? (
        <>
          <div className={`
            max-w-md text-center md:text-left relative z-10
            transform transition-all duration-700 ease-out
            ${subscriptionVisible ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}
          `}>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 animate-pulse">
              You are already a {subscriptionStatus === 'Large Box' ? 'Large Box' : 'Small Box'} Subscriber!
            </h2>
            <p className="text-base md:text-lg text-gray-700 mb-2 leading-relaxed">
              Thank you for being a valued subscriber. As a {subscriptionStatus === 'Large Box' ? 'Large Box' : 'Small Box'} subscriber, you enjoy the convenience of fresh, authentic African groceries delivered to your door every month.
            </p>
            <p className="text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
              You can now proceed to select your items for this month. Simply click the button below to start customizing your box.
            </p>
            <button
              onClick={() => navigate(subscriptionStatus === 'Large Box' ? '/largebox' : '/smallbox')}
              disabled={isButtonDisabled}
              className={`
                px-6 py-3 rounded-lg font-semibold text-lg max-sm:text-sm 
                transition-all duration-300 transform
                ${isButtonDisabled 
                  ? 'bg-gray-400 cursor-not-allowed' 
                  : 'bg-gradient-to-r from-[#007D44] to-[#005A32] hover:from-[#F0B241] hover:to-[#E09A2A] hover:scale-105 hover:shadow-lg active:scale-95'
                } 
                text-white shadow-md
              `}
            >
              {isButtonDisabled ? (
                `Next order available in: ${countdown}`
              ) : (
                `Go to ${subscriptionStatus === 'Large Box' ? 'Large Box' : 'Small Box'} Page`
              )}
            </button>
          </div>
          <div className={`
            flex-shrink-0 transform transition-all duration-700 ease-out
            ${subscriptionVisible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-8 opacity-0 scale-95'}
          `}>
            <img 
              src={subbox} 
              alt="Fresh Food Basket" 
              className="md:w-[450px] h-auto rounded-lg shadow-lg object-cover mx-auto md:mx-0 hover:scale-105 transition-transform duration-300" 
            />
          </div>
        </>
      ) : (
        <>
          <div className={`
            max-w-md text-center md:text-left relative z-10
            transform transition-all duration-700 ease-out
            ${subscriptionVisible ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'}
          `}>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 bg-gradient-to-r from-[#007D44] to-[#F0B241] bg-clip-text text-transparent">
              Food Subscription Plan
            </h2>
            <p className="text-base md:text-lg text-gray-700 mb-4 leading-relaxed">
              Enjoy fresh, authentic African groceries delivered to your door every month. Choose your subscription plan and experience the convenience of high-quality, flavorful ingredients right at home.
            </p>
            <button
              onClick={openModal}
              className="
                px-6 py-3 bg-gradient-to-r from-[#007D44] to-[#005A32] text-white 
                rounded-lg font-semibold text-lg 
                hover:from-[#F0B241] hover:to-[#E09A2A] 
                transform hover:scale-105 hover:shadow-lg 
                active:scale-95 transition-all duration-300
                shadow-md
              "
            >
              Subscribe Now
            </button>
          </div>

          <div className={`
            flex-shrink-0 transform transition-all duration-700 ease-out
            ${subscriptionVisible ? 'translate-x-0 opacity-100 scale-100' : 'translate-x-8 opacity-0 scale-95'}
          `}>
            <img 
              src={subbox} 
              alt="Fresh Food Basket" 
              className="w-64 md:w-[450px] h-auto rounded-lg shadow-lg object-cover mx-auto md:mx-0 hover:scale-105 transition-transform duration-300" 
            />
          </div>
        </>
      )}
    </div>

     {/* Products sections */}
     <div ref={hotProductsRef} id="hot-products">
        <ProductSection title="Hot Products" products={hotProducts} autoScroll />
        <ProductSection title="FRESH VEGGIES." products={freshVeggies} autoScroll />
        <ProductSection title="Refreshing Beverages" products={beverages} autoScroll />
      </div>
  
    <Footer />

    {/* Enhanced Modal for subscription - MOVED OUTSIDE OF OTHER COMPONENTS */}
    {isModalOpen && (
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
        <div className="
          bg-white p-6 rounded-2xl shadow-2xl max-w-md mx-4 relative
          transform transition-all duration-500 ease-out
          animate-slideInScale
        ">
          {/* Close Icon */}
          <button
            onClick={cancelModal}
            className="
              absolute top-3 right-3 text-gray-400 hover:text-gray-600 
              transition-all duration-200 text-2xl
              hover:scale-110 hover:rotate-90 transform
            "
            aria-label="Close"
          >
            <IoCloseOutline />
          </button>
          
          <h3 className="text-2xl font-bold mb-4 text-center bg-gradient-to-r from-[#007D44] to-[#F0B241] bg-clip-text text-transparent">
            Subscribe to a Monthly Food Plan
          </h3>
          <p className="text-gray-700 mb-4 text-center leading-relaxed">
            Subscribe to a monthly food plan and enjoy the convenience of choosing your items each month. Pick any 10 items for $99 or any 6 items for $59, depending on your selected plan. Every month, you'll receive an email allowing you to select the items you want for that month.
          </p>

          <p className="text-gray-700 mb-4 text-center leading-relaxed">
            Items priced above $20 can only be selected once. Items priced between $10 and $20 can be selected up to twice. Items priced below $10 have no selection limit, allowing you to choose as many as you'd like.
          </p>

          <div className="flex items-center mb-4 group">
            <input
              type="checkbox"
              checked={isAccepted}
              onChange={() => setIsAccepted(!isAccepted)}
              className="mr-3 w-4 h-4 accent-[#007D44] transform transition-transform group-hover:scale-110"
            />
            <span className="text-gray-700">I accept the subscription terms and conditions</span>
          </div>

          {isAccepted && (
            <div className="animate-slideInUp">
              <div className="mt-4">
                <label className="block text-gray-700 mb-2 font-semibold">Choose your box option:</label>
                <select
                  onChange={(e) => setSelectedPlan(e.target.value)}
                  className="
                    w-full px-3 py-2 border-2 border-gray-200 rounded-lg
                    focus:border-[#007D44] focus:ring-2 focus:ring-[#007D44]/20
                    transition-all duration-300
                  "
                >
                  <option value="">Select a plan</option>
                  <option value="large">Large Box Plan - $99</option>
                  <option value="small">Small Box Plan - $59</option>
                </select>
              </div>

              <button
                onClick={closeModal}
                className="
                  mt-6 w-full bg-gradient-to-r from-[#007D44] to-[#005A32] text-white 
                  px-4 py-3 rounded-lg font-semibold
                  hover:from-[#F0B241] hover:to-[#E09A2A] 
                  transform hover:scale-105 active:scale-95
                  transition-all duration-300 flex justify-center items-center
                  shadow-lg disabled:opacity-50 disabled:cursor-not-allowed
                "
                disabled={!selectedPlan || loading}
              >
                {loading ? (
                  <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                ) : (
                  "Confirm Subscription"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    )}

    {/* Additional CSS for enhanced animations */}
    <style jsx>{`
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideInScale {
        from { 
          opacity: 0; 
          transform: scale(0.8) translateY(20px); 
        }
        to { 
          opacity: 1; 
          transform: scale(1) translateY(0); 
        }
      }
      
      @keyframes slideInUp {
        from { 
          opacity: 0; 
          transform: translateY(20px); 
        }
        to { 
          opacity: 1; 
          transform: translateY(0); 
        }
      }
      
      .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
      .animate-slideInScale { animation: slideInScale 0.5s ease-out; }
      .animate-slideInUp { animation: slideInUp 0.3s ease-out; }
    `}</style>
  </div>
  
  );
}

export default App;